module.exports = __webpack_public_path__ + "img/gif6.84224a26.gif";